// Angular
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// Third party
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

// Self
import { IAccount } from './../services/authentication.interface';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class SelfSignupSettingGuard {
  constructor(
    private auth: AuthenticationService,
    private router: Router,
  ) {}

  canActivateChild(): Observable<boolean> {
    return this.auth.account$.pipe(
      filter((account: IAccount) => !!account?.id),
      map((account: IAccount) => {
        if (account.isHubSelfSignup) {
          this.router.navigate(['/404']);
        }
        // if the account doesn't have this setting then do nothing. Let the ClaimGuard decide the rest
        return true;
      }),
    );
  }
}
